import React, { Component } from "react";

import Tabs from "../../components/Tabs/Tabs";
import "../common.css";
import "./CustomerList.css";

import CustomerList from "./CustomerList";
import Staffs from "./Staffs";

export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultTab: "Customer",
    };
  }

  componentDidMount() {
    this.setState({
      defaultTab:
        window.location.pathname === "/commercial/customer-list"
          ? "Customer"
          : "Commercial",
    });
    // this.retrieveEmployeeList();
  }

  render() {
    return (
      <div className={"page"}>
        {this.props.userInfo?.user.role.includes("Commercial") && (
          <div className="text-start mb-2" style={{ fontSize: "14px" }}>
            <div>Store : {this.props.userInfo?.user.seller}</div>
            <div>Location : {this.props.userInfo?.user.store_location}</div>
          </div>
        )}

        {window.location.pathname === "/customer-list" && (
          <Tabs
            defaultTab={this.state.defaultTab}
            resetTab={() => this.setState({ defaultTab: undefined })}
          >
            <div label="Customer">
              <CustomerList
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                role={this.props.userInfo.user.role}
                userInfo={this.props.userInfo?.user}
              />
            </div>
            <div label="Commercial">
              <Staffs
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                userInfo={this.props.userInfo}
                role={this.props.userInfo.user.role}
                setDefaultTab={() =>
                  this.setState({ defaultTab: "Commercial" })
                }
                storeLocationId={this.props.userInfo?.user.store_location_id}
                isCommercial={true}
              />
            </div>
            <div label="Cin7">
              <Staffs
                protectedFetch={this.props.protectedFetch}
                selectedbrandID={this.props.selectedbrandID}
                userInfo={this.props.userInfo}
                role={this.props.userInfo.user.role}
                setDefaultTab={() => this.setState({ defaultTab: "Cin7" })}
                storeLocationId={this.props.userInfo?.user.store_location_id}
                isCin7={true}
              />
            </div>
            {["Admin", "Staff", "Commercial Admin"].includes(
              this.props?.userInfo?.user?.role
            ) ? (
              <div label="Approval">
                <Staffs
                  protectedFetch={this.props.protectedFetch}
                  selectedbrandID={this.props.selectedbrandID}
                  userInfo={this.props.userInfo}
                  role={this.props.userInfo.user.role}
                  setDefaultTab={() =>
                    this.setState({ defaultTab: "Approval" })
                  }
                  storeLocationId={this.props.userInfo?.user.store_location_id}
                  isApproval={true}
                />
              </div>
            ) : null}
          </Tabs>
        )}
        {window.location.pathname === "/commercial/customer-list" && (
          <div className="border-2">
            <h4>Customer</h4>
            <CustomerList
              protectedFetch={this.props.protectedFetch}
              selectedbrandID={this.props.selectedbrandID}
              role={this.props.userInfo.user.role}
              userInfo={this.props.userInfo?.user}
              isCommercial={true}
            />
          </div>
        )}
        {window.location.pathname === "/commercial/staffs" && (
          <div className="border-2">
            <h4>Staff</h4>
            <Staffs
              protectedFetch={this.props.protectedFetch}
              selectedbrandID={this.props.selectedbrandID}
              userInfo={this.props.userInfo}
              role={this.props.userInfo.user.role}
              setDefaultTab={() => this.setState({ defaultTab: "Commercial" })}
              storeLocationId={this.props.userInfo?.user.store_location_id}
            />
          </div>
        )}
      </div>
    );
  }
}
